module.exports = __webpack_public_path__ + "static/media/thankyou.41cdcf11.png";